import { ApiHosts, handleResponseOld, makePost } from './helpers';
import { ItemFacets } from '@/types/ItemFacets';

/**
 * @category Item API
 * @see fetchItemFacets
 */
type FetchItemFacetsParams = {
    authToken?: string;
    deployment: string;
    ids: number[];
};
/**
 * @category Item API
 * @see fetchItemFacets
 */
type FetchItemFacetsResponse = {
    data: ItemFacets[];
    message: string;
    success: boolean;
};
/**
 * Fetch Item facets by given ids from Item API service
 * @function fetchItemFacets
 * @category Item API
 * @param {FetchItemFacetsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/item-facets
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-item-facets.ts
 */
export const fetchItemFacets = ({ authToken, deployment, ids }: FetchItemFacetsParams) =>
    new Promise<FetchItemFacetsResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'spa/small/item-facets',
            authToken,
            deployment,
            path: ApiHosts.ItemApi,
        });
        request.send({ ids });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchItemFacets,
};
